import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.pruefobjekt-aktualisieren';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksPruefobjektAktualisierenEffects {

    PruefobjektAktualisieren$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_PRUEFOBJEKT_AKTUALISIEREN),
        mergeMap((x: ac.PostPruefobjektAktualisierenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postPruefobjektAktualisieren(x.pruefobjektModelRequest).pipe(
                map((result: any) => {
                    return new ac.PostPruefobjektAktualisierenErfolgreichAction(result, x.pruefobjektModelRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostPruefobjektAktualisierenFehlerAction(error, x.pruefobjektModelRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminCommandService);
        }
        return this.service;
    }
}
